import PropTypes from "prop-types";
import React from "react";
import Row from "../Grid/Row";

const ButtonRow = ({ children }) => (
  <Row middle center>
    {children}
  </Row>
);

ButtonRow.propTypes = {
  children: PropTypes.node
};

export default ButtonRow;



// WEBPACK FOOTER //
// ./src/components/ButtonRow/ButtonRow.jsx